import { cn } from '../../lib/cn';

/** "Anna Verdi" -> "AV"; un'email o un nome solo -> le prime due lettere. */
function iniziali(nome: string): string {
  const parole = nome.replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean);
  if (parole.length >= 2) return (parole[0][0] + parole[parole.length - 1][0]).toUpperCase();
  return (parole[0] ?? '?').slice(0, 2).toUpperCase();
}

/** Il tondino con le iniziali davanti al nome di una persona. */
export function Iniziali({ nome, className }: { nome: string; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gray-100 text-[11px] font-semibold text-neutral-600',
        className,
      )}
    >
      {iniziali(nome)}
    </span>
  );
}
